import { Center, Container, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export default function Home() {
  const { t } = useTranslation();
  return (
    <Container px={{ base: 4, md: 6 }}>
      <Center py={{ base: 8, md: 12 }}>
        <Text 
          textAlign="center" 
          fontWeight="900" 
          color="primary" 
          fontSize={{ base: "2xl", sm: "3xl", md: "4xl" }}
          lineHeight={{ base: "shorter", md: "short" }}
          px={{ base: 2, md: 0 }}
        >
          {t("welcomeToOzeLoans")} 👋🏼
        </Text>
      </Center>
    </Container>
  );
}
